import { render, staticRenderFns } from "./ContactInfoCard.vue?vue&type=template&id=299a223d&scoped=true&"
import script from "./ContactInfoCard.vue?vue&type=script&lang=ts&"
export * from "./ContactInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInfoCard.vue?vue&type=style&index=0&id=299a223d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a223d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText})
